<template>
    <list-layout :tableTools="toggleTableTools">
      <template slot="header">
        <BaseHeader :content="header" />
      </template>
      <template slot="table-core">
        <base-table-pagination
          :total="pagination.total"
          :currentPage="pagination.currentPage"
          :perPage="pagination.pageSize"
          @changeCurrentPage="changeCurrentPage"
          @changePerPage="changePerPage"
        ></base-table-pagination>
        <div class="flex flex-row w-100">
          <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
          <base-table-search @toggleFilters="toggleFilters" />
        </div>
      </template>
      <template slot="table-tags">
        <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
      </template>
      <template slot="table-component">
        <kendo-grid-component
          ref="grid"
          v-model="selected"
          value-key="idRegla"
          :id-vista="idVista"
          :spanish="spanish"
          :data='data'
          :kendo="kendo"
          :loading='isGeneralLoading'
          :selectedField="selectedField"
          @actionclick='openPath'
          @datastatechange='dataStateChange'>
        </kendo-grid-component>
      </template>
      <template slot="layout-extend">
        <base-footer>
          <template slot="actions">
            <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' 
              :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
            <base-button-responsive mode="primary" :text="$t('rules.link_rules')" icon="plus" @click="golinkRuleToWorkflow" 
              :loading="isGeneralLoading"/>
          </template>
        </base-footer>
        <base-table-select-actions-expand
          :visibility="hasSelected"
          :selected="rowsSelected"
          :total="rowsTotal"
        >
          <template slot="commons">
            <base-button size="xs" mode="tools" @click="unselect">
              <base-icon name="vall" size="sm" class="mr-1" />
              {{$t('app.unselect')}}
            </base-button>
          </template>
          <template slot="more">
            <base-button-item-list theme="dark" @click="unlink">
              <base-icon name="unlink" class="mr-2" />
                {{$t('app.unlink_entity')}}
            </base-button-item-list>
          </template>
        </base-table-select-actions-expand>
        <workflow-link-rules-dialog 
          :dialogOpen="linkWorkflowToRuleDialog" 
          :ruleId="$route.params.id" 
          @toggleDialog="toggleDialogs" 
          @applyDialog="applyLinkHandler" 
          />
        <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
        <create-search-dialog 
          :numberSearches="numberSearches"
          :idVista="idVista" 
          :dialogOpen="saveSearchDialog" 
          :tags="tags" 
          @toggleDialog="toggleDialogSearches" 
          @applyDialog="applySearchHandler" />
        <filter-panel-searches 
          ref="filterPanelSearches" 
          :idVista="idVista" 
          :vuexnamespace="vuexnamespace" 
          :panelOpen="searchesPanel" 
          @togglePanel="toggleSearchesDialog" 
          @applyFilters="applyFiltersHandler" 
          @updateNumberSearches="updateNumberSearches"/>
      </template>
    </list-layout>
  </template>
  
<script>
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/RulesByApprovalWorkflowFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import { i18n } from '@/i18n'
import KendoGridComponent from '@/components/KendoGridComponentV2.vue'
import WorkflowLinkRulesDialog from '@/components/WorkflowLinkRulesDialog.vue'
  
import { getWorkflow } from '@/services/configurations/workflow/getWorkflow'
  
import { getApprovalWorkflowRulesPag } from '@/services/configurations/rules/getApprovalWorkflowRulesPag'
import { getApprovalWorkflowRulesExcel } from '@/services/configurations/rules/getApprovalWorkflowRulesExcel'
  
import { linkWorkflowToRules } from '@/services/configurations/workflow/linkWorkflowToRules'
import { unlinkWorkflowToRules } from '@/services/configurations/workflow/unlinkWorkflowToRules'
  
export default {
  name: 'rules-by-approval-workflow',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    KendoGridComponent,
    WorkflowLinkRulesDialog,
  },
  data: function () {
    return {
      idVista: 98,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // All
      loadingExcel: false,
      showModal: false,
      linkWorkflowToRuleDialog: false,
      spanish: true,
      header: {
        title: i18n.t('rules.rules_link'),
        icon: 'config',
        breadcrumb: null,
        url: 'configurations/approvalworkflows/details'
      },
      vuexnamespace: 'approvalworkflowrules',
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      selected: [],
    }
  },
  computed: {
    labelBtnExcel: function () {
      if (this.hasSelected) return `${i18n.t('app.export_excel')} (${i18n.t('app.selected')})`
      return i18n.t('app.export_excel')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    setLabelTowShow: function () {
      return this.showAllRows ? i18n.t('app.only_selected') : i18n.t('app.see_all')
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    columns () {
      return [
        { field: 'selected', width: '50px', headerSelectionValue: this.areAllSelected, reorderable: false, groupable: false },
        ...this.kendo.columns
      ]
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    role: function () {
      return this.$store.getters['auth/role']
    }
  },
  watch: {
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
  },
  created: function () {
  },
  mounted: async function () {
    const idFlujo = this.$route.params.id
  
    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
  
    const breadcrumbs = []
    if (this.role === 7 || this.role === 8 || this.role === 3) {
      breadcrumbs.push({
        path: this.role === 3 ? 'configurationssa' : 'configurations',
        name: i18n.t('configurations.header')
      })
    } else {
      breadcrumbs.push({
        path: 'configurations',
        name: i18n.t('configurations.header')
      })
    }
    breadcrumbs.push({ path: 'configurations/approvalworkflows', name: i18n.t('approval_workflow.header') })
    
    const cabeceraStored = this.$store.getters['app/headerBreadCrumb']
    if (this.$store.getters['app/fromRouteName'] !== null && cabeceraStored) {
      breadcrumbs.push({ path: '', name: cabeceraStored })
    } else {
      const flujo = await this.downloadData(idFlujo)
      breadcrumbs.push({ path: '', name: flujo.Nombre })
      this.$store.commit('app/setheaderBreadCrumb', flujo.Nombre)
    }
  
    this.header.breadcrumb = breadcrumbs
  
    this.data = await this.applyFilters()
  },
  methods: {
    openPath: function (event) {
      // this.$router.push({ name: 'configurations/tags/details', params: { id: event.dataItem.IdUsuario } })
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    toggleDialogs: function () {
      this.linkWorkflowToRuleDialog = !this.linkWorkflowToRuleDialog
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    dataStateChange: async function (event) {
      this.data = await this.applyFilters()
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        idFlujoaprobacion: this.$route.params.id,
        nombre: data.name ? data.name.value : null,
        prioridad: data.prioridad ? data.prioridad.value : null,
        Activa: data.activo ? data.activo.value : null,
        DetenerEjecucion: data.DetenerEjecucion ? data.DetenerEjecucion.value : null,
        EnUso: data.enUso ? data.enUso.value : null,
        nombreGrupo: data.nombreGrupo ? data.nombreGrupo.value : null,
        nombreGrupoPropietario: data.nombreGrupoPropietario ? data.nombreGrupoPropietario.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
      const payload = { order: objOrder.order, grupos: objColumnas }
      if (this.hasSelected) {
        const selectedIDs = this.selected.map(x => x.idRegla)
        payload.listaIDs = selectedIDs
      }
      try {
        const response = await getApprovalWorkflowRulesExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'flujo-reglas.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        idFlujoaprobacion: this.$route.params.id,
        nombre: data.name ? data.name.value : null,
        prioridad: data.prioridad ? data.prioridad.value : null,
        Activa: data.activo ? data.activo.value : null,
        DetenerEjecucion: data.DetenerEjecucion ? data.DetenerEjecucion.value : null,
        EnUso: data.enUso ? data.enUso.value : null,
        nombreGrupo: data.nombreGrupo ? data.nombreGrupo.value : null,
        nombreGrupoPropietario: data.nombreGrupoPropietario ? data.nombreGrupoPropietario.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        this.data = await this.getItemsData(objOrder, params)
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(`${i18n.t('feedback.error.general')} ${error}`)
      }
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      this.data = res.Respuesta
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getApprovalWorkflowRulesPag(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      this.unselect()
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    downloadData: async function (id) {
      let flujo = null
      try {
        this.$store.commit('setIsLoading', true)
  
        const params = {
          IdFlujoAprobacion: id
        }
        flujo = await getWorkflow(params)
        if (flujo.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', flujo))
        } else {
          flujo = flujo.Flujo
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return flujo
    },
    unselect: function () {
      this.selected = []
    },
    unlink: async function () {
      const selected = this.selected
      await this.unlinkHandler(selected)
      // for await (const element of selected) {
      //   await this.unlinkHandler(element.IdTag)
      // }
      this.data = await this.applyFilters()
    },
    unlinkHandler: async function (grupos) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { Reglas: this.selected }
        const response = await unlinkWorkflowToRules(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.entity_unlinked_msg'), 'success')
          this.selected = []
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    golinkRuleToWorkflow: function () {
      this.linkWorkflowToRuleDialog = !this.linkWorkflowToRuleDialog
    },
    applyLinkHandler: async function (tags) {
      this.linkTagToUser = false
      await this.linkHandler(tags)
      this.applyFilters()
    },
    linkHandler: async function (idReglas) {
      try {
        this.$store.commit('setIsLoading', true)
        const IdFlujoAprobacion = this.$route.params.id
        const payload = { IdFlujoAprobacion, Reglas: idReglas }
        const response = await linkWorkflowToRules(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.entity_linked_msg'), 'success')
          this.selected = []
          this.toggleDialogs()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>
  
